import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { EmitenteAtivoProvider } from './context/EmitenteAtivoContext';
import './styles/index.css';
import { registerSW } from 'virtual:pwa-register';

if ('caches' in window) {
  window.caches.delete('asset-cache').catch(() => undefined);
}

// Em autoUpdate o app recarrega sozinho quando o SW novo assume o controle,
// evitando ficar preso em bundle antigo do cache (PWA aberta há dias não
// veria deploys novos sem isso).
registerSW({
  immediate: true,
  onRegisteredSW(_url, reg) {
    if (reg) setInterval(() => reg.update().catch(() => undefined), 15 * 60 * 1000);
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000
    }
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <EmitenteAtivoProvider>
            <App />
          </EmitenteAtivoProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
